import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../index';
import { ButtonLabel } from './styled';
var MarkAllAsReadButton = function MarkAllAsReadButton(_ref) {
  var handleMarkAllNotificationsRead = _ref.handleMarkAllNotificationsRead;
  return /*#__PURE__*/React.createElement(ButtonLabel, {
    appearance: "subtle-link",
    onClick: handleMarkAllNotificationsRead
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.markAllAsRead));
};
export default MarkAllAsReadButton;